<template>
  <p class="p-4 z-40 bg-black bg-opacity-70 text-white flex items-center">
    <slot />
  </p>
</template>
